import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';
import { Typography } from '@/components/Typography';

export const Wrapper = styled(Box)`
  ${({ theme }) => css`
    ${theme.media.md.up} {
      width: 38%;
      padding-right: ${theme.spacing(8)};
      border-right: 1px solid ${theme.colors.defaultAdd5};
      display: flex;
      flex-direction: column;
    }
  `}
`;

export const DescriptionWrapper = styled(Flex)`
  flex-direction: column;
  align-items: center;

  ${({ theme }) => css`
    ${theme.media.md.up} {
      flex-direction: row;
      align-items: flex-start;
      justify-content: space-between;
    }
  `}
`;

export const Description = styled(Typography)`
  ${({ theme }) => css`
    margin-bottom: ${theme.spacing(2)};
    line-height: 22px;
    width: 100%;
    ${theme.media.md.up} {
      width: 252px;
      margin-bottom: 0;
      margin-right: ${theme.spacing(2)};
    }
  `}
`;

export const FlexSpace = styled(Box)`
  ${({ theme }) => css`
    display: none;
    ${theme.media.md.up} {
      display: block;
      flex: 1;
    }
  `}
`;
export const WarrantyWrapper = styled(Box)`
  position: relative;
`;

export const WarrantyDuration = styled(Typography)`
  position: absolute;
  top: 42px;
  left: 50%;
  transform: translateX(-50%) translateY(10%);
  font-size: 53px;

  ${({ theme }) => css`
    font-family: ${theme.fontFamilies.italianPlate};
    font-weight: ${theme.fontWeights.bold};
    color: ${theme.colors.primaryDark};
    top: 34px;
    font-size: ${theme.fontSizes.h2};
    ${theme.media.md.up} {
      top: 32px;
    }
  `}
`;

export const Duration = styled(Typography)`
  text-align: center;

  ${({ theme }) => css`
    font-weight: ${theme.fontWeights.bold};
    margin-top: ${theme.spacing(2)};
    margin-bottom: ${theme.spacing(1.375)};
    color: ${theme.colors.default};
    ${theme.media.md.up} {
      text-align: left;
      margin-top: ${theme.spacing(4)};
      margin-bottom: ${theme.spacing(1)};
    }
  `}
`;

export const DurationValue = styled(Typography)`
  ${({ theme }) => css`
    font-weight: ${({ theme }) => theme.fontWeights.bold};
    color: ${theme.colors.default};
  `}
`;

export const TermsText = styled(Typography)`
  ${({ theme }) => css`
    text-align: center;
    font-family: ${theme.fontFamilies.openSans};
    font-size: ${theme.fontSizes.p2};
    margin-bottom: ${theme.spacing(1.75)};
    ${theme.media.md.up} {
      text-align: left;
    }
  `}
`;
export const Terms = styled(Box)`
  ${({ theme }) => css`
    margin-bottom: ${theme.spacing(2)};
    line-height: 22px;
    & > P > a {
      color: ${theme.colors.default};
      &:hover {
        color: ${theme.colors.default};
      }
      font-weight: ${theme.fontWeights.regular};
    }
    & > P {
      text-align: center;
      margin-top: ${theme.spacing(0)};
    }
    text-align: center;
    ${theme.media.md.up} {
      margin-bottom: ${theme.spacing(0)};
      padding-bottom: ${theme.spacing(2.5)};
      text-align: left;
      & > P {
        text-align: left;
      }
    }
  `}
`;
export const FlexGrowSpace = styled(Box)`
  ${({ theme }) => css`
    ${theme.media.md.up} {
      flex-grow: 1;
    }
  `}
`;
export const ExtendWrapper = styled(Box)`
  ${({ theme }) => css`
    background-color: ${theme.colors.secondaryLightGrey};
    padding: ${theme.spacing(2)} 0};
    ${theme.media.md.up} {
      padding: ${theme.spacing(2)};
      border-top: none;
      border-bottom: none;
    }
  `}
`;

export const ExtendDetails = styled(Box)`
  ${({ theme }) => css`
    margin-bottom: ${theme.spacing(2)};

    &:first-of-type {
      margin-right: ${theme.spacing(3)};
    }

    ${theme.media.md.up} {
      &:first-of-type {
        margin-right: ${theme.spacing(8)};
      }
    }
  `}
`;

export const ExtendDetailsYears = styled(Typography)`
  position: relative;
  text-transform: uppercase;
  font-weight: ${({ theme }) => theme.fontWeights.regular};
  &:before {
    content: '';
    display: block;
    position: absolute;
    height: 2px;
    bottom: -1px;
    left: 2px;
    background-color: ${({ theme }) => theme.colors.primary};
    width: ${({ theme }) => theme.spacing(2)};
  }

  ${({ theme }) => css`
    font-family: ${theme.fontFamilies.italianPlate};
    font-size: ${theme.fontSizes.h5};
    color: ${theme.colors.primaryBlue};
    margin-bottom: ${theme.spacing(1)};
  `}
`;

export const ExtendDetailsValue = styled(Typography)`
  border-bottom: 2px solid ${({ theme }) => theme.colors.primary};
`;

export const ExtendDetailsInfo = styled(Typography)`
  text-transform: uppercase;

  ${({ theme }) => css`
    font-weight: ${theme.fontWeights.bold};
    font-family: ${theme.fontFamilies.italianPlate};
    font-size: ${theme.fontSizes.h6};
    color: ${theme.colors.black};
  `}
`;

export const DescriptionText = styled(Typography)`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes.p2};
    line-height: 22px;
  `}
`;
